import React, { FC, useEffect, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormField, FormInputNumber } from '../../../common/form';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmSourcesFormModal.translations.json';
import { AlgorithmSourceFormDataType } from './schema/types';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-sources-period',
);
addTranslations(translations);

export interface AlgorithmSourcePeriodProps {
  name: string;
  rowIndex: number;
}

export const AlgorithmSourcePeriod: FC<AlgorithmSourcePeriodProps> = (
  props,
) => {
  const { name, rowIndex } = props;
  const { t } = useTranslation();
  const sources = useWatch({ name: `sources` });
  const { setValue } = useFormContext();

  const areDbSources = useMemo(
    () =>
      sources.some(
        (item: AlgorithmSourceFormDataType) => item.sourceType === 'DB',
      ),
    [sources],
  );

  const isIntermediate = useMemo(
    () => sources[rowIndex]?.sourceType === 'INTERMEDIATE',
    [sources, rowIndex],
  );

  useEffect(() => {
    if (isIntermediate) setValue(name, 0);
  }, [name, isIntermediate, setValue]);

  if (!areDbSources && !isIntermediate) {
    return (
      <FormField name={name} label={t('numberOfPreviousPeriod.label')}>
        <FormInputNumber
          name={name}
          precision={0}
          addonBefore="T"
          formatter={(value) => (value > 0 ? '+' + value : value)}
        />
      </FormField>
    );
  }
};
